import { render, staticRenderFns } from "./TaxonomyVoc.vue?vue&type=template&id=c7f29030&"
import script from "./TaxonomyVoc.vue?vue&type=script&lang=js&"
export * from "./TaxonomyVoc.vue?vue&type=script&lang=js&"
import style0 from "./TaxonomyVoc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports